import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import { InventoryProvider } from './context';
import { InventoryPath } from './routes';

const Supplier = lazy(() => import('./pages/Supplier/Supplier'));
const Laboratory = lazy(() => import('./pages/Laboratory/Laboratory'));
const Category = lazy(() => import('./pages/Category/Category'));
const Product = lazy(() => import('./pages/Product/Product'));
const ProductList = lazy(() => import('./pages/ProductList/ProductList'));
const Lots = lazy(() => import('./pages/Lots/Lots'));
const Customer = lazy(() => import('./pages/Customer/Customer'));
const Services = lazy(() => import('./pages/Services/Services'));

export const InventoryRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense>
      <Routes>
        <Route path={InventoryPath.Supplier} element={<Supplier />} />
        <Route path={InventoryPath.Laboratory} element={<Laboratory />} />
        <Route path={InventoryPath.Category} element={<Category />} />
        <Route path={InventoryPath.Product} element={<Product />} />
        <Route path={InventoryPath.ProductList} element={<ProductList />} />
        <Route path={InventoryPath.Lots} element={<Lots />} />
        <Route path={InventoryPath.Customer} element={<Customer />} />
        <Route path={InventoryPath.Services} element={<Services />} />
        <Route path="*" element={<Redirect to={InventoryPath.Supplier} replace />} />
      </Routes>
    </Suspense>
  );
};

export const InventoryRouter: React.FC = () => (
  <InventoryProvider>
    <InventoryRoutes />
  </InventoryProvider>
);
